;
define("facets_facet_browse.tpl", function(){});

